/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PatientPatchModel } from '../models';
// @ts-ignore
import type { PatientResponseModel } from '../models';
// @ts-ignore
import type { PatientSearch } from '../models';
// @ts-ignore
import type { SearchFhirPatients200Response } from '../models';
/**
 * FHIRPatientApi - axios parameter creator
 * @export
 */
export const FHIRPatientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get patient info on the basis of name or patient ID
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatient', 'patientId', patientId)
            const localVarPath = `/api/v1/fhir/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch a patient
         * @param {string} patientId 
         * @param {PatientPatchModel} patientPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPatient: async (patientId: string, patientPatchModel: PatientPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('patchPatient', 'patientId', patientId)
            // verify required parameter 'patientPatchModel' is not null or undefined
            assertParamExists('patchPatient', 'patientPatchModel', patientPatchModel)
            const localVarPath = `/api/v1/fhir/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a patient
         * @param {PatientSearch} patientSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirPatients: async (patientSearch: PatientSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSearch' is not null or undefined
            assertParamExists('searchFhirPatients', 'patientSearch', patientSearch)
            const localVarPath = `/api/v1/fhir/patient/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIRPatientApi - functional programming interface
 * @export
 */
export const FHIRPatientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIRPatientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get patient info on the basis of name or patient ID
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatient(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatient(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPatientApi.getPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch a patient
         * @param {string} patientId 
         * @param {PatientPatchModel} patientPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPatient(patientId: string, patientPatchModel: PatientPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPatient(patientId, patientPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPatientApi.patchPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search a patient
         * @param {PatientSearch} patientSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFhirPatients(patientSearch: PatientSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFhirPatients200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFhirPatients(patientSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPatientApi.searchFhirPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIRPatientApi - factory interface
 * @export
 */
export const FHIRPatientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIRPatientApiFp(configuration)
    return {
        /**
         * 
         * @summary Get patient info on the basis of name or patient ID
         * @param {FHIRPatientApiGetPatientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient(requestParameters: FHIRPatientApiGetPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponseModel> {
            return localVarFp.getPatient(requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch a patient
         * @param {FHIRPatientApiPatchPatientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPatient(requestParameters: FHIRPatientApiPatchPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchPatient(requestParameters.patientId, requestParameters.patientPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a patient
         * @param {FHIRPatientApiSearchFhirPatientsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirPatients(requestParameters: FHIRPatientApiSearchFhirPatientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchFhirPatients200Response> {
            return localVarFp.searchFhirPatients(requestParameters.patientSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIRPatientApi - interface
 * @export
 * @interface FHIRPatientApi
 */
export interface FHIRPatientApiInterface {
    /**
     * 
     * @summary Get patient info on the basis of name or patient ID
     * @param {FHIRPatientApiGetPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPatientApiInterface
     */
    getPatient(requestParameters: FHIRPatientApiGetPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponseModel>;

    /**
     * 
     * @summary Patch a patient
     * @param {FHIRPatientApiPatchPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPatientApiInterface
     */
    patchPatient(requestParameters: FHIRPatientApiPatchPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Search a patient
     * @param {FHIRPatientApiSearchFhirPatientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPatientApiInterface
     */
    searchFhirPatients(requestParameters: FHIRPatientApiSearchFhirPatientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchFhirPatients200Response>;

}

/**
 * Request parameters for getPatient operation in FHIRPatientApi.
 * @export
 * @interface FHIRPatientApiGetPatientRequest
 */
export interface FHIRPatientApiGetPatientRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPatientApiGetPatient
     */
    readonly patientId: string
}

/**
 * Request parameters for patchPatient operation in FHIRPatientApi.
 * @export
 * @interface FHIRPatientApiPatchPatientRequest
 */
export interface FHIRPatientApiPatchPatientRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPatientApiPatchPatient
     */
    readonly patientId: string

    /**
     * 
     * @type {PatientPatchModel}
     * @memberof FHIRPatientApiPatchPatient
     */
    readonly patientPatchModel: PatientPatchModel
}

/**
 * Request parameters for searchFhirPatients operation in FHIRPatientApi.
 * @export
 * @interface FHIRPatientApiSearchFhirPatientsRequest
 */
export interface FHIRPatientApiSearchFhirPatientsRequest {
    /**
     * 
     * @type {PatientSearch}
     * @memberof FHIRPatientApiSearchFhirPatients
     */
    readonly patientSearch: PatientSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRPatientApiSearchFhirPatients
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRPatientApiSearchFhirPatients
     */
    readonly pgSize?: number
}

/**
 * FHIRPatientApi - object-oriented interface
 * @export
 * @class FHIRPatientApi
 * @extends {BaseAPI}
 */
export class FHIRPatientApi extends BaseAPI implements FHIRPatientApiInterface {
    /**
     * 
     * @summary Get patient info on the basis of name or patient ID
     * @param {FHIRPatientApiGetPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPatientApi
     */
    public getPatient(requestParameters: FHIRPatientApiGetPatientRequest, options?: RawAxiosRequestConfig) {
        return FHIRPatientApiFp(this.configuration).getPatient(requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch a patient
     * @param {FHIRPatientApiPatchPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPatientApi
     */
    public patchPatient(requestParameters: FHIRPatientApiPatchPatientRequest, options?: RawAxiosRequestConfig) {
        return FHIRPatientApiFp(this.configuration).patchPatient(requestParameters.patientId, requestParameters.patientPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a patient
     * @param {FHIRPatientApiSearchFhirPatientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPatientApi
     */
    public searchFhirPatients(requestParameters: FHIRPatientApiSearchFhirPatientsRequest, options?: RawAxiosRequestConfig) {
        return FHIRPatientApiFp(this.configuration).searchFhirPatients(requestParameters.patientSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }
}

